export const AdvisorScenarioSimulatorPanel = ({ activeScenarioKey, onSelectScenario, simulator }) => {
  if (!simulator?.scenarios?.length) return null;

  const activeScenario = simulator.scenarios.find((item) => item.key === activeScenarioKey) || simulator.scenarios[0];

  return (
    <div className="rounded-[24px] border border-[#001935]/10 bg-[#001935] px-5 py-5 text-white shadow-[0_18px_36px_rgba(0,25,53,0.16)]" data-testid="signature-advisor-scenario-simulator-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="signature-advisor-scenario-simulator-eyebrow">Scenario simulator</p>
      <h4 className="mt-2 text-xl font-semibold text-white" data-testid="signature-advisor-scenario-simulator-headline">{simulator.headline}</h4>

      <div className="mt-4 flex flex-wrap gap-2" data-testid="signature-advisor-scenario-simulator-options">
        {simulator.scenarios.map((scenario) => {
          const isActive = scenario.key === activeScenario.key;
          return (
            <button
              className={`rounded-full border px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] transition ${
                isActive ? "border-[#D4AF37] bg-[#D4AF37] text-[#1A1A1A]" : "border-white/20 bg-white/8 text-[#f3e7b8] hover:bg-white/12"
              }`}
              data-testid={`signature-advisor-scenario-option-${scenario.key}`}
              key={scenario.key}
              onClick={() => onSelectScenario(scenario.key)}
              type="button"
            >
              {scenario.label}
            </button>
          );
        })}
      </div>

      <div className="mt-4 rounded-[20px] border border-white/10 bg-white/8 px-4 py-4" data-testid="signature-advisor-scenario-simulator-active-card">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#D4AF37]" data-testid="signature-advisor-scenario-simulator-active-label">{activeScenario.label}</p>
        <p className="mt-3 text-sm leading-7 text-white" data-testid="signature-advisor-scenario-simulator-active-summary">{activeScenario.summary}</p>
        <p className="mt-3 rounded-[16px] border border-white/10 bg-[#06284f] px-4 py-3 text-sm leading-7 text-[#dbe4f0]" data-testid="signature-advisor-scenario-simulator-active-recommendation">
          {activeScenario.recommendation}
        </p>
      </div>
    </div>
  );
};